import type { ComponentType, ElementType, PropsWithChildren } from 'react';
import React from 'react';
import * as styles from '../css/media.css';
import { classNames } from '../utils';

type Variant = 'left' | 'right' | 'center';

export type MediaProps<T> = T & {
    component: ElementType<T>;
    variant: Variant;
    className?: string;
};

// eslint-disable-next-line @typescript-eslint/comma-dangle
const Media = <T,>({ variant, className, component, ...rest }: PropsWithChildren<MediaProps<T>>) => {
    const Component = component as ComponentType<T>;

    return (
        <Component
            className={classNames(
                className,
                getImageBorderStyle(variant),
            )}
            {...rest as T}
        />
    );
};

function getImageBorderStyle(variant: Variant) {
    if (variant === 'left') {
        return styles.imageLeftSideBorder;
    }

    if (variant === 'right') {
        return styles.imageRightSideBorder;
    }

    return styles.imageDefaultBorder;
}

export default Media;
